import { Component, input, output } from '@angular/core';

import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'lib-edit-menu',
  imports: [MatIcon, MatIconButton, MatMenu, MatMenuItem, MatMenuTrigger],
  templateUrl: './edit-menu.component.html',
})
export class EditMenuComponent {
  readonly canEdit = input(true);
  readonly canDelete = input(true);
  readonly edit = output<boolean>();
  readonly delete = output<boolean>();

  onDelete() {
    this.delete.emit(true);
  }

  onEdit() {
    this.edit.emit(true);
  }
}
